module.exports = __webpack_public_path__ + "img/logo-REE.c712af79.jpg";